var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask-img",style:([_vm.maskUrl]),on:{"click":_vm.changeImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }